import styled from "styled-components";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";

export const StyledButton = styled.button`
  margin: 0.35rem auto;
  display: block;
  padding: 4px 1.4rem;
  font-size: 0.75rem;
  background: transparent;
  border: 1px solid #9e9e9e;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #f4f4f4;
  }
`;
export const StyledAvatar = styled(Avatar)`
  &.MuiAvatar-root {
    width: 1.75rem;
    height: 1.75rem;
    margin-right: 6px;
  }
`;

export const StyledPaper = styled(Paper)`
  &.MuiPaper-root {
    position: absolute;
    top: calc(100% + 0.01rem);
    right: 1rem;
    z-index: 1000;
    width: clamp(240px, 32vw, 280px);
    max-width: calc(100vw - 2rem);
    max-height: calc(100vh - 5rem);
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 0px 0px 0px 8px;
    margin-right: 0.9rem;
    border: 1px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .MuiDivider-root {
      margin: 0.25rem 0;
    }

    .MuiMenuItem-root {
      padding: 0.55rem 1rem;
      column-gap: 0.6rem;
    }

    .MuiListItemIcon-root {
      min-width: 24px;
    }

    .MuiSvgIcon-root {
      font-size: 1.1rem;
    }

    .MuiListItemText-root span,
    .MuiTypography-root {
      font-size: 0.85rem;
    }
  }
`;
